// eslint-disable-next-line no-useless-escape
export const JWTRegex =
  '^[A-Za-z0-9-_=]+\\.[A-Za-z0-9-_=]+\\.?[A-Za-z0-9-_.+/=]*$'

export const flagsUrl =
  import.meta.env.VITE_FLAGS_URL ?? 'https://flags.labra.io'

export const flagsCacheTTLSeconds = (() =>
  parseInt(import.meta.env.VITE_FLAGS_TTL_SECONDS ?? '300'))()

export const serviceId = import.meta.env.VITE_SERVICE_ID ?? 'webapp'

export const serviceEnvironment = import.meta.env.VITE_ENVIRONMENT ?? 'qa'

export const getUrlPrefix = (env: string) => {
  const normalized = (env ?? 'qa').trim().toLowerCase()

  if (normalized === 'prd' || normalized === 'prod') {
    return ''
  }

  if (
    normalized === 'qa' ||
    normalized === 'q1' ||
    normalized === 'q2' ||
    normalized === 'dev' ||
    normalized === 'development' ||
    normalized === 'local' ||
    !normalized
  ) {
    return 'qa.'
  }

  if (normalized === 'stg' || normalized === 'staging') {
    return 'stg.'
  }

  return `${normalized}.`
}

const labraServiceUrl = (path: string) =>
  `https://${getUrlPrefix(serviceEnvironment)}api.labra.io/${path}`

export const engineServiceUrl =
  import.meta.env.VITE_ENGINE_SERVICE_URL ?? labraServiceUrl('engine/v1')

export const labravAWSEngineServiceUrl =
  import.meta.env.VITE_AWS_ENGINE_SERVICE_URL ??
  labraServiceUrl('aws_engine/v1')

export const labravAWSEngineServiceV2Url = labravAWSEngineServiceUrl.replace(
  '/v1',
  '/v2'
)

export const identityServiceUrl =
  import.meta.env.VITE_IDENTITY_SERVICE_URL ?? labraServiceUrl('identity/v1')

export const crmServiceUrl =
  import.meta.env.VITE_CRM_SERVICE_URL ?? labraServiceUrl('crm/v1')

export const mappingConfigurationServiceUrl =
  import.meta.env.VITE_MAPPING_SERVICE_URL ??
  labraServiceUrl('mapping_configuration/v1')

export const cloudAccountServiceUrl =
  import.meta.env.VITE_CLOUD_SERVICE_URL ?? labraServiceUrl('ide/v1')

export const marketplaceServiceUrl =
  import.meta.env.VITE_MARKETPLACE_URL ?? labraServiceUrl('marketplace')

export const intelligenceServiceUrl =
  import.meta.env.VITE_INTELLIGENCE_SERVICE_URL ??
  labraServiceUrl('intelligence/v1')

export const intelligenceChatServiceUrl =
  import.meta.env.VITE_INTELLIGENCE_CHAT_SERVICE_URL ??
  labraServiceUrl('intelligence_chat/v1')

export const chatServiceUrl = labraServiceUrl('agent_chat')

/** Public CDN base for files stored in the `flyout-assets` S3 bucket. */
export const flyoutAssetsUrl = 'https://assets.flyout.labra.io'

/** S3 bucket backing chat document uploads + flyout image assets. */
export const bucketNameImage = 'flyout-assets'

export const MarketplaceSearchUrl =
  import.meta.env.VITE_MARKET_PLACE_SEARCH_SERVICE_URL ??
  labraServiceUrl('search/v1')

export const azureMarketplaceServiceUrl =
  import.meta.env.VITE_AZURE_MARKET_PLACE_SERVICE_URL ??
  labraServiceUrl('azure_marketplace/v1')

export const gcpMarketplaceServiceUrl =
  import.meta.env.VITE_GCP_MARKET_PLACE_SERVICE_URL ??
  labraServiceUrl('gcp_marketplace/v1')

export const cloudfaasServiceUrl =
  import.meta.env.VITE_CLOUDFAAS_URL ?? labraServiceUrl('cloudfaas/v1')

export const azureEngineServiceUrl =
  import.meta.env.VITE_AZURE_ENGINE_SERVICE_URL ??
  labraServiceUrl('azure_engine/v1')

export enum CRMTypes {
  salesforce = 'salesforce',
  hubspot = 'hubspot',
  connectwise = 'connectwise',
  labra = 'labra',
}

export enum crmEnv {
  STAGING = 'staging',
  PRODUCTION = 'production',
}

export const helpDrawerUrl = 'https://helpcenter.labra.io/hc/en-us'

export const labraSupportUrl = 'https://helpcenter.labra.io/requests/new'

export const viteSegmentApiWriteKey =
  import.meta.env.VITE_SEGMENT_API_WRITE_KEY ?? ''
